import React from 'react';
import { Icon } from 'semantic-ui-react';

/**
 * 
 * @param {amount, round, currency} props 
 */
function AmountProvider(props) {

  const getSymbol = value => {
    switch (value) {
      case "EUR":
        return <Icon name="euro" />
      case "USD":
        return <Icon name="dollar" />
      case "GBP":
        return <Icon name="pound" />
      default:
        return value;
    }
  }

  const numberFormat = (number, decimals=2, dec_point='.', thousands_point=' ') => {
    number = parseFloat(number).toFixed(decimals);
    number = number.replace(".", dec_point);

    let splitNum = number.split(dec_point);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
    number = splitNum.join(dec_point);
    return number;
  }

  return (
    <div style={{ display: 'inline' }}>
      {props.before && props.before} {numberFormat(props.amount)} {getSymbol(props.currency)}
    </div>
  )
}

export default AmountProvider;